import BaseIconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';

export const IconButton = styled(BaseIconButton)`
  & .MuiButtonBase-root,
  .MuiIconButton-label {
    color: inherit;
  }
`;
